module.exports = __webpack_public_path__ + "img/about-us-banner-mobile.4f625110.png";